export default __webpack_public_path__ + "static/media/SpinnerCircle.36273ffc.svg";